import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { ScrollToTop } from "@/components/ScrollToTop";
import { LandingPage } from "@/components/LandingPage";
import { AdminPage } from "@/components/AdminPage";
import PrivacyPage from "@/components/PrivacyPage";
import TermsPage from "@/components/TermsPage";
import AcceptableUsePage from "@/components/AcceptableUsePage";
import LegalRequestsPage from "@/components/LegalRequestsPage";
import RefundPolicyPage from "@/components/RefundPolicyPage";
import ReportsAndAppealsPage from "@/components/ReportsAndAppealsPage";
import SafetyPage from "@/components/SafetyPage";
import ContactPage from "@/components/ContactPage";
import AboutPage from "@/components/AboutPage";
import ThankYouPage from "@/components/ThankYouPage";
import PricingPage from "@/components/PricingPage";
import PaymentSuccessPage from "@/components/PaymentSuccessPage";
import PaymentCancelPage from "@/components/PaymentCancelPage";
import ResetPasswordPage from "@/components/ResetPasswordPage";
import BetaPage from "@/components/BetaPage";
import BetaAdminPage from "@/components/BetaAdminPage";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/beta" element={<BetaAdminPage />} />
        <Route path="/beta" element={<BetaPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/acceptable-use" element={<AcceptableUsePage />} />
        <Route path="/legal-requests" element={<LegalRequestsPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
        <Route path="/report-and-appeals" element={<ReportsAndAppealsPage />} />
        <Route path="/safety" element={<SafetyPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/payment/cancel" element={<PaymentCancelPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
